// extracted by mini-css-extract-plugin
export default {"box":"StyleModule_box__Bd18i"};